// Tool-approval chip — shown when the agent requests approval for a write.
// Extracted from ChatDrawer.tsx; pure, driven by props.

import { type PendingApproval } from './types';

export function PendingChip({
  approval, onApply, onSkip, busy,
}: { approval: PendingApproval; onApply: () => void; onSkip: () => void; busy: boolean }) {
  return (
    <div
      role="group"
      aria-label={`Approve pending action: ${approval.summary}`}
      className="border border-blue-300 bg-blue-50 rounded p-2 text-xs space-y-1"
    >
      <div className="font-semibold text-blue-900">⚠ {approval.summary}</div>
      <details>
        <summary className="cursor-pointer text-blue-700">View input</summary>
        <pre className="bg-white border border-blue-200 rounded p-1 mt-1 overflow-x-auto text-[10px]">
          {JSON.stringify(approval.input, null, 2)}
        </pre>
      </details>
      <div className="flex gap-2 mt-2">
        <button
          onClick={onApply}
          disabled={busy}
          className="px-2 py-1 rounded bg-blue-600 text-white text-xs disabled:opacity-50 hover:bg-blue-700"
        >
          Apply
        </button>
        <button
          onClick={onSkip}
          disabled={busy}
          className="px-2 py-1 rounded bg-slate-200 text-slate-700 text-xs disabled:opacity-50 hover:bg-slate-300"
        >
          Skip
        </button>
      </div>
    </div>
  );
}
